'use client';

import Image from 'next/image';
import Link from 'next/link';
import { ArrowRight, Play, MapPin } from 'lucide-react';

export default function HomeHeader() {
  return (
    <header className="hero-wrapper">
      {/* Background Image - Full width */}
      <div className="hero-background">
        <Image
          src="/images/hero-img.png"
          alt="Payroll Dashboard"
          fill
          priority
          className="hero-bg-image"
        />

        {/* Dark Overlay */}
        <div className="hero-overlay" />

        {/* Orange Gradient Accent */}
        <div className="hero-gradient" />
      </div>

      {/* Content */}
      <div className="hero-container">
        <div className="hero-content">
          {/* Trust Badge */}
          <div className="hero-trust-badge">
            <span className="hero-trust-dot" />
            <span className="hero-trust-text">
              Trusted by 300+ businesses in Nigeria & Ghana
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="hero-title">
          <span className="hero-title-first">
            Payroll that keeps up with wherever
          </span>
          <span className="highlight">
            your business grows.
          </span>
        </h1>

          {/* Subtitle */}
          <p className="hero-subtitle">
            The all-in-one payroll platform built for businesses <br></br> operating across Nigeria and Ghana — fully <br></br> compliant, beautifully simple.
          </p>

          {/* CTA Buttons */}
          <div className="hero-actions">
            <Link href="/request-demo" className="hero-btn-primary">
              Request a Demo
            </Link>

            <Link href="/platform" className="hero-btn-secondary">
              <Play size={18} className="hero-btn-icon" fill="currentColor" />
              See the platform
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
